var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFethtz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_19307)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601562 8.36881L13.818 0.738281L27.0345 8.36881V23.6299L13.818 31.2604L0.601562 23.6299V8.36881Z",
    stroke: "url(#paint0_linear_2070_19307)",
    strokeWidth: 1.45455
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2070_19307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8178 2.87109L25.1864 9.43473V22.562L13.8178 29.1256L2.44922 22.562V9.43473L13.8178 2.87109Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2070_19307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8182 29.818C21.4498 29.818 27.6364 23.6314 27.6364 15.9998C27.6364 8.36825 21.4498 2.18164 13.8182 2.18164C6.18661 2.18164 0 8.36825 0 15.9998C0 23.6314 6.18661 29.818 13.8182 29.818Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 30C21.732 30 28 23.732 28 16C28 8.26801 21.732 2 14 2C6.26801 2 0 8.26801 0 16C0 23.732 6.26801 30 14 30Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2070_19307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6579 28.3158C20.3725 28.3158 25.8158 22.8725 25.8158 16.1579C25.8158 9.44327 20.3725 4 13.6579 4C6.94327 4 1.5 9.44327 1.5 16.1579C1.5 22.8725 6.94327 28.3158 13.6579 28.3158Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6582 24.6095C18.3257 24.6095 22.1095 20.8257 22.1095 16.1582C22.1095 11.4908 18.3257 7.70703 13.6582 7.70703C8.99077 7.70703 5.20703 11.4908 5.20703 16.1582C5.20703 20.8257 8.99077 24.6095 13.6582 24.6095Z",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 1.41176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.333 12.8965H2.98252C2.32744 12.8965 1.79639 13.4275 1.79639 14.0826V18.0265C1.79639 18.6816 2.32744 19.2127 2.98252 19.2127H24.333C24.9881 19.2127 25.5191 18.6816 25.5191 18.0265V14.0826C25.5191 13.4275 24.9881 12.8965 24.333 12.8965Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.333 12.8965H2.98252C2.32744 12.8965 1.79639 13.4275 1.79639 14.0826V18.0265C1.79639 18.6816 2.32744 19.2127 2.98252 19.2127H24.333C24.9881 19.2127 25.5191 18.6816 25.5191 18.0265V14.0826C25.5191 13.4275 24.9881 12.8965 24.333 12.8965Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6579 27.4253C19.8812 27.4253 24.9262 22.3803 24.9262 16.157C24.9262 9.93366 19.8812 4.88867 13.6579 4.88867C7.43464 4.88867 2.38965 9.93366 2.38965 16.157C2.38965 22.3803 7.43464 27.4253 13.6579 27.4253Z",
    stroke: "#F2F2F2",
    strokeWidth: 1.69412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.658 26.5367C19.39 26.5367 24.0367 21.89 24.0367 16.158C24.0367 10.426 19.39 5.7793 13.658 5.7793C7.92599 5.7793 3.2793 10.426 3.2793 16.158C3.2793 21.89 7.92599 26.5367 13.658 26.5367Z",
    stroke: "#F2F2F2",
    strokeWidth: 0.564706
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6571 10.6699L13.5835 10.9199V18.1747L13.6571 18.2481L17.0246 16.2576L13.6571 10.6699Z",
    fill: "black",
    fillOpacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6571 10.6699L10.2896 16.2576L13.6571 18.2482V14.7269V10.6699Z",
    fill: "black",
    fillOpacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6567 18.8861L13.6152 18.9366V21.5209L13.6567 21.642L17.0263 16.8965L13.6567 18.8861Z",
    fill: "black",
    fillOpacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6571 21.642V18.8861L10.2896 16.8965L13.6571 21.642Z",
    fill: "black",
    fillOpacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6572 18.2478L17.0248 16.2572L13.6572 14.7266V18.2478Z",
    fill: "black",
    fillOpacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2896 16.2572L13.6571 18.2478V14.7266L10.2896 16.2572Z",
    fill: "black",
    fillOpacity: 0.67
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2070_19307",
    x1: -9.31078,
    y1: 15.9994,
    x2: 30.3386,
    y2: 15.9994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E3B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184658,
    stopColor: "#39E4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C7BCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_19307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6364,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2070_19307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3158,
    height: 24.3158,
    fill: "white",
    transform: "translate(2 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFethtz);
export default __webpack_public_path__ + "static/media/fethtz.1a16c45ea8a42fedb7602888ef51201d.svg";
export { ForwardRef as ReactComponent };